import { render, staticRenderFns } from "./KSRMechanik.vue?vue&type=template&id=48dfbcae&scoped=true&"
import script from "./KSRMechanik.vue?vue&type=script&lang=js&"
export * from "./KSRMechanik.vue?vue&type=script&lang=js&"
import style0 from "./KSRMechanik.vue?vue&type=style&index=0&lang=css&"
import style1 from "./KSRMechanik.vue?vue&type=style&index=1&id=48dfbcae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dfbcae",
  null
  
)

export default component.exports